export function getAuthorUrl(id, firstName, lastName, authorLocale, baseUrl) {
    let localePrefix = ''
    if (authorLocale !== 'GB') {
      localePrefix = authorLocale.toLowerCase() + '/'
    }
    const url = `${baseUrl}/${localePrefix}author/${id}-${firstName}-${lastName}`
    return url
  }